import { createContext, useState, useContext } from 'react';
import { usePaystackPayment } from 'react-paystack';
import api from '../api';
import { useAuth } from "../context/AuthContext";
import { generateUID, generateEpoch } from '../util';

const payKey = process.env.REACT_APP_PAYSTACK

export const OrderContext = createContext(null);

const genEpochUID = () => `${generateEpoch()}${generateUID(7)}`;

export const OrderProvider = ({ children }) => {
  const [amount, setAmount] = useState(0);
  const [orderState, setOrderState] = useState({ phone: '', email: '', address: '' });
  const [loading, setLoading] = useState(false);
  const [uid, setUid] = useState(genEpochUID());
  const { user } = useAuth();
  const config = {
    channels: ['card', 'bank', 'ussd', 'qr', 'mobile_money', 'bank_transfer'],
    reference: uid,
    email: orderState.email,
    amount: amount * 100,
    publicKey: payKey,
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setOrderState(prevState => ({ ...prevState, [name]: value }));
  }

  const genUID = () => {
    setUid(genEpochUID());
  }

  const initializePayment = usePaystackPayment(config);

  const orderNow = async () => {
    const orderData = { "phone": orderState.phone, "requestId": uid, "address": orderState.address, "userId": user.user_Id }

    try {
      setLoading(true);
      const res = await api.post('Order', (orderData))
      setLoading(false)
      return res;
    } catch (error) {
      setLoading(false)
      return error;
    }
  }

  return (
    <OrderContext.Provider value={{
      onChange, phone: orderState.phone, address: orderState.address,
      amount, orderNow, loading, setAmount,
      setOrderState, genUID, initializePayment, uid
    }}>
      {children}
    </OrderContext.Provider>
  )
}

export const useOrder = () => useContext(OrderContext)